import { UserRepo } from './repo'
import { Network } from '../../utils/network'
import { Events } from '../../utils/servicesEvents'
import { login } from './use-cases/login'
import { Formatter } from './formatter'
import { saveDeviceToken } from './use-cases/saveDeviceToken'
import { register } from './use-cases/register'
import { Commons } from '../../utils/commons'
import urls from './raws/urls.json'
import { updateUserData } from './use-cases/updateUserData'
import { loginWithGoogle } from './use-cases/loginWithGoogle'
import { getUserData } from './use-cases/getUserData'

class UserController {
  static async refreshData(data) {
    return
  }

  static async login(data) {
    const userConnected = await UserController.isConnected()
    if (userConnected) Events.dispatchEvent('logout_requested')
    const res = await login(data, urls, Formatter, Network)
    if (!res.success) return Events.dispatchEvent('login_failed', res)
    await UserController.saveUser(res.user)
    Events.dispatchEvent('login_done', res.user)
  }

  static async loginWithGoogle() {
    Events.dispatchEvent('start_loading', { title: 'Connexion en cours' })
    const userConnected = await UserController.isConnected()
    if (userConnected) Events.dispatchEvent('logout_requested')
    const res = await loginWithGoogle(urls, Network)
    if (!res.success) return Events.dispatchEvent('google_login_failed', res)
    Events.dispatchEvent('finish_loading')
    Events.dispatchEvent('url_opening_required', {
      url: res.redirectUrl,
      allowManyOpening: true,
      openInCurrentTab: true,
    })
  }

  static async makeGoogleUserConnexion(googleUserData) {
      const data = {
        email: googleUserData.email,
        password: googleUserData.id,
        firstName: googleUserData.firstName,
        countryCode: googleUserData.countryCode || 'BJ',
        lastName: googleUserData.lastName || 'none',
        pictureUrl: googleUserData.pictureUrl,
      }
      const userRes = await getUserData(data.email, urls, Formatter, Network)

      if(userRes.success){
        await UserController.saveUser(userRes.user)
        Events.dispatchEvent('google_login_done', userRes.user)
        return
      }
      Events.dispatchEvent('finish_loading')
      await new Promise((r)=>{setTimeout(r,300)})

        const passwordPrompt = await Events.sendDataRequestResolve(
          'customPrompt',
          {
            title: 'Saisissez le mot de passe à utiliser',
            formFields: [
              {
                type: 'password',
                propertyName: 'password',
                label: 'mot de passe',
                placeHolder: '********',
                defaultValue: '',
                inputProps: {
                  minLenght: 6,
                },
                required: true,
                class: 'col-span-12',
              },
            ],
          },
        )
        console.log(passwordPrompt)
        if (!passwordPrompt.success || !passwordPrompt.data.password) return
        data.password = passwordPrompt.data.password
        Events.dispatchEvent('start_loading')
        const registerRes = await register(data, urls, Formatter, Network)
        await new Promise((r)=>{setTimeout(r,300)})
        if (!registerRes.success) {
          Events.dispatchEvent('google_registration_failed', registerRes)
          return
        }

      await UserController.saveUser(registerRes.user)
      Events.dispatchEvent('google_registration_done', registerRes.user)
    
  }

  static async updateUserData(data) {
    const userConnected = await UserController.isConnected()
    if (!userConnected) {
      Events.dispatchEvent('logout_requested')
      return
    }
    const res = await updateUserData(data, urls, Formatter, Network)
    if (!res.success) {
      Events.dispatchEvent('user_not_updated', res)
      return
    }
    await UserController.saveUser(res.user)
    Events.dispatchEvent('user_data_updated', res.user)
  }

  static async register(data) {
    const userConnected = await UserController.isConnected()
    if (userConnected) Events.dispatchEvent('logout_requested')
    const res = await register(data, urls, Formatter, Network)
    if (!res.success) return Events.dispatchEvent('registration_failed', res)
    await UserController.saveUser(res.user)
    Events.dispatchEvent('registration_done', res.user)
  }

  static async saveUserDeviceToken(token = null) {
    const userConnected = await UserController.isConnected()
    console.log('userConnected', userConnected, token)
    if (!userConnected) Events.dispatchEvent('device_token_saving_failed')
    const res = await saveDeviceToken(token, urls, Network)
    if (!res.success) Events.dispatchEvent('device_token_saving_failed')
    else Events.dispatchEvent('device_token_saved')
  }

  static async isConnected() {
    const user = await UserController.getUserData()
    return !!user
  }

  static async getUserData() {
    const db = await UserRepo.getDb()
    if (!db) return null
    const user = await db.get()
    return Formatter.buildUserEntity(user)
  }

  static async saveUser(user) {
    const db = await UserRepo.getDb()
    if (!db) return Events.dispatchEvent('failed_to_save_user')
    await db.clean()
    await db.save(user)
    Events.dispatchEvent('user_updated')
  }

  static async initListeners() {
    Events.handleEvent('login_requested', async data => {
      UserController.login(data)
    })
    Events.handleEvent('login_with_google_required', async data => {
      UserController.loginWithGoogle(data)
    })
    Events.handleEvent('update_user_data', async data => {
      UserController.updateUserData(data)
    })
    Events.handleEvent('registration_requested', async data => {
      UserController.register(data)
    })
    Events.handleEvent('request:userData', async ({ responseId }) => {
      const user = await UserController.getUserData()
      Events.dispatchEvent(responseId, Commons.changeToJson(user))
    })
    Events.handleEvent('device_token_available', async ({ deviceToken }) => {
      UserController.saveUserDeviceToken(deviceToken)
    })
    Events.handleEvent('google_login_data_available', async data => {
      UserController.makeGoogleUserConnexion(data)
    })
    Events.handleEvent('clean_all_data_requested', async () => {
      const db = await UserRepo.getDb()
      await db.clean()
      Events.dispatchEvent('user_updated')
      Events.dispatchEvent('logout_done')
    })
  }
}

export { UserController }
